import SearchResult from './SearchResult.vue'
Vue.component('cms-search-result', SearchResult)

//const phoenixApp = createApp({
const phoenixApp = new Vue({
  el: '#vue-phoenix-search-app',
});
phoenixApp.$mount();